/* ADD Knowledge categories */
export const ADD_IMAGE = "ADD_IMAGE"
export const ADD_IMAGE_SUCCESS = "ADD_IMAGE_SUCCESS"
export const ADD_IMAGE_CLEAN = "ADD_IMAGE_CLEAN"
export const ADD_IMAGE_ERROR = "ADD_IMAGE_ERROR"
